import { DrawingStandardSettings } from 'apps/studio/components/settings/fields/Drawing/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Drawing/advanced'

export const DrawingSettings = [
  FieldSettingsPanel(DrawingStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
